{
    "eyebrow": "دليل المستخدم",
    "title": "دليلك",
    "subtitle": "مكتوب لما تفعله هنا. اقرأه كاملاً في يومك الأول، أو جد فيه ما تحتاجه وحده في يومك الثالث.",
    "reading_time": "قراءة في {{count}} دقيقة",
    "chapters_count": "{{count}} فصول",
    "start_reading": "ابدأ القراءة",
    "print": "طباعة",
    "contents": "المحتويات",
    "progress": "قرأت {{done}} من {{total}}",
    "reset_progress": "ابدأ من جديد",
    "mark_read": "علّمه مقروءاً",
    "marked_read": "مقروء",
    "step": "الخطوة {{number}}",
    "open_screen": "افتح هذه الشاشة",
    "back_to_top": "العودة إلى الأعلى",
    "tone": {
        "note": "ملاحظة",
        "tip": "نصيحة",
        "caution": "يستحق الانتباه"
    },
    "glossary": {
        "title": "كلمات لها معنى محدّد هنا",
        "subtitle": "عشرة مصطلحات تُستخدم بدقة في هذه المنصّة، وتستحق قراءة واحدة.",
        "search": "رشِّح المصطلحات",
        "search_placeholder": "اكتب كلمة",
        "empty": "لا يطابق أي مصطلح ذلك."
    },
    "faq": {
        "title": "أسئلة الأسبوع الأول",
        "subtitle": "ما يسأل عنه الناس فعلاً، بإجابات صريحة."
    },
    "other_roles": {
        "title": "دليل دور آخر",
        "subtitle": "لكل دور دليل مختلف. فالمدير الذي لا يرى ما قيل لموظفيه لا يستطيع مساءلتهم بموجبه.",
        "read": "اقرأ هذا الدليل",
        "yours": "دليلك",
        "back_to_mine": "العودة إلى دليلي",
        "viewing": "أنت تقرأ الدليل المكتوب لـ{{role}}."
    },
    "footer": {
        "title": "حين تفضّل النقر على القراءة",
        "body": "العرض التعريفي جولة من أربع دقائق في الشاشات التي يستخدمها دورك، ومرجع الواجهات يوثّق الواجهة البرمجية خلفها.",
        "showcase": "خُذ الجولة",
        "api": "مرجع الواجهات"
    },
    "invitation": {
        "title": "دليلك جاهز",
        "body": "دليل مكتوب لدورك — ما هذه المنصّة بالنسبة إليك، وكيف يجري يوم عملك فيها، والشاشات التي ستعمل عليها. نحو ست دقائق.",
        "action": "افتح دليلي",
        "dismiss": "ليس الآن"
    }
}
